//show/hide the overlay when hovering on/off any desktop nav item
$(document).ready(function() {
  $('.header__nav-item').on('mouseover', '*', function() {
    $('.overlay').addClass("show");
  });

  $('.header__nav-item').on('mouseout', '*', function() {
    $('.overlay').removeClass("show");
  });

  //hide the language selector first option label
  $('select.gt_selector.notranslate option[value=""]').remove();

  //footer logo - with social icons
  $('.block-social_media_YeVfDQ').prepend('<div class="footer-logo"><a href="https://codyjames.com/"><img src="https://d2aovoe6slpue4.cloudfront.net/web_assets/cody_james/img/cj_footer_icon.png" alt="Cody James" width="100" height="100"/></a></div>');
  
  //START - STYLES FILTER
  var stylesArray = ["1000X","100X","10X","13MWZ","15X","20X","30X","3X","4X","500X","505","50X","514","517","527","535","550","559","5X","Lace Up","6X","710","711","715","721","Lace Up","8X","936","Advanced Comfort","Affordable Fancy","Athletic","Aura","Baseball Cap","Basic Belt","Basket Weave","Bathroom Decor","Bedding","Bedroom Decor","Black Label","Blanket","Blue Label","Boot Barn Exclusive","Booties","Booty Up","Boyfriend","Branding Irons","Bronze Label","Buckle Belt","Buffalo Felt","Button Down","Cargo","Carpenter","Casual","Casual Cap","Cattleman Crease","Chelsea","Christmas","Chukka Shoe","Cold Shoulder","College","Concealed Carry","Concho","Cool Vantage","Cowboy","Cowboy Cut","Cropped","Crossbody","Crushable","Curtain","Denim","Dinnerware","Dress","Dress Hat","Drinkware","Driving Shoe","Embellished","Embroidered","Engineer Boot","Equestrian","Exotic","Fashion","Fedora","Felt","Festival","Fishing","Flannel","Flats","Frame","Fringe","Frontier","Full Size","Fur Felt","Gambler","George Strait","Glassware","Graphic","Green Label","Gun Accessory","Handmade","Hard Hat","Harness","Heels","High/Low Top","Hiking","Home Decor","Hooded","Hoodies","Hunting","Inlay","King Size","Kitchen Decor","Knee/Thigh High","Knife","Lace","Lace-Up","Lacer/Packer","Leather","Logger Boot","Long Sleeve","Maxi","Metallic","Midi","Mini","Motorcycle","Muck","Mules/Slides","Open Road","Outback","Oxfords","Palm Leaf","Patriotic","Performance","Pet Accessory","Phone Accessory","Pillow","Pinch Front Crease","Polo","Postal","Pull-On","Pumps","Queen Size","Rain","Relentless","Riata","Riding","Riding Boots","Romeo/Hog","Roper","Rubber","Service Industry","Shacket/Shirt Jacket","Sheets","Sherpa","Short Barn","Short Boots","Short Sleeve","Silver Label","Sleeveless","Slip-On","Slope Front Crease","Snaps","Snow","Softshell","Stacked Heel","Stainless","Stockman","Strapless","Straw","Sunhat","Swim","T-shirt","Tactical","Tall Boot","Tank Top","Tooled","Tooled Belt","Tote","Towel","Twin Size","Utensils","UV Protection","Vintage","Visor","Waders","Wall Decor","Wedding","Wedding Accessory","Wedge","Western Gifts","White Label","Wide Foot/Calf","Wool","Wool Felt","Work","Work Sneaker","Wrinkle Free","Wristlet","Zipper/Shoe Boot"];

  // MutationObserver is used to detect changes in the DOM
  const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
              // Check for added nodes with the specified class
              $(mutation.addedNodes).find('div[id*="Filter-filter.p.tag-template"] .facets__item').each(function() {
                  $('div[id*="Filter-filter.p.tag-template"] .facets__item').each(function() {
                      var value = $(this).find('.product-option__input').val();
                      if ($.inArray(value, stylesArray) !== -1) {
                          $(this).closest('.facets__item').addClass('show');
                      } else {
                          $(this).closest('.facets__item').addClass('hidden');
                      }
                  });
              });

              // Check for added nodes that are the element with the specified class
               $(mutation.addedNodes).filter('div[id*="Filter-filter.p.tag-template"] .facets__item').each(function() {
                 $('div[id*="Filter-filter.p.tag-template"] .facets__item').each(function() {
                      var value = $(this).find('.product-option__input').val();
                      if ($.inArray(value, stylesArray) !== -1) {
                          $(this).closest('.facets__item').addClass('show');
                      } else {
                          $(this).closest('.facets__item').addClass('hidden');
                      }
                  });
              });
          }
      });
    if ($('div[id*="Filter-filter.p.tag-template"] .facets__item.show').length == 0) {
      $('div[id*="Filter-filter.p.tag-template"]').closest('.facets__accordion-section').hide();
    }
    //END - STYLES FILTER
  });

  // Configure the observer to watch for changes to the element's children
  const config = { childList: true, subtree: true };

  // Start observing the document body for changes
  observer.observe(document.body, config);

  // Initial check for existing elements on page load
   $('div[id*="Filter-filter.p.tag-template"] .facets__item').each(function() {
     $('div[id*="Filter-filter.p.tag-template"] .facets__item').each(function() {
          var value = $(this).find('.product-option__input').val();
          if ($.inArray(value, stylesArray) !== -1) {
              $(this).closest('.facets__item').addClass('show');
          } else {
              $(this).closest('.facets__item').addClass('hidden');
          }
      });
  });
  if ($('div[id*="Filter-filter.p.tag-template"] .facets__item.show').length == 0) {
    $('div[id*="Filter-filter.p.tag-template"]').closest('.facets__accordion-section').hide();
  }
});

$(document).ready(function() {
  //remove section block to fix spacing, if no pdp reviews/special image/video  
  /*if($('.jdgm-rev-widg').attr('data-number-of-reviews') == 0) {
    $("div[id*='__1745532168a22de499']").hide();
  }*/
  if ($('#special-product-image').length < 1 ) {
    $("div[id*='_N3RT4T']").hide();
  }
  if ($('#special-product-video').length < 1 ) {
    $("div[id*='_TTCmad']").hide();
  }
});


//CORDIAL
// footer - email_signup
$(document).on('click','button.newsletter__button', function(){
    var email = $('.newsletter__field input[type="email"]').val().trim();
    var formValidation = true;

    var regexEmail = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (String(email).match(regexEmail) == null ) {
      formValidation = false;
    }

    if (formValidation){
      var auth_data = {
        email: email
      }			

      var contact_data = {
        'channels': {
          'email': {
            'subscribeStatus': 'subscribed'
          }
        },
        'source_create': 'footer',   
        'signup_source': 'footer',
        'welcome_signup': true
      };

      var properties = {
        'source_create': 'footer',   
        'signup_source': 'footer',
        'welcome_signup': true
      };

      crdl([				
        ['contact', auth_data, contact_data,{'forceSubscribe': {email: true}, 'upsert': true}],
        ['event', 'email_signup', properties]
      ]);
    }
});

//register page - account_create
$('#create_customer button.button').bind({
  click: function(){
    var firstName = $('input[name="customer[first_name]"]').val().trim();
    var lastName = $('input[name="customer[last_name]"]').val().trim();
    var email = $('input[name="customer[email]"]').val().trim();
    var password = $('input[name="customer[password]"]').val().trim();
    var formValidation = true;
    
    var regexPassword = /^.{6,}$/;
    if ( String(password).match(regexPassword) == null ) {
      formValidation = false;
    }

    if (!email || !firstName || !lastName || !password) {
      formValidation = false;
    }
    
    var loginProperties = {
      'email': email
    };
    
    if (formValidation && $('.errors').length == 0){
      var auth_data = {
        email: email
      }

      var contact_data = {
        'channels': {
            'email': {
              'subscribeStatus': 'none'
            }
        },        
        'first_name': firstName,
        'last_name': lastName,
        'source_create': 'myaccount'
      };      


      crdl([       
        ['contact', auth_data, contact_data,{'upsert': true}],
        ['event', 'account_create'],
        ['event', 'login', loginProperties]
      ]);
    }
  }
});

//login page - login
$('#customer_login button.button').bind({
  click: function(){
    var username = $('.form-customer--login input[name="customer[email]"]').val().trim();
        
    var auth_data = {
        email: username
    }
        
    var contact_data = {
        'channels': {
            'email': {
                'address': username      
            }
        }
    };
    
    var properties = {
        "email": username
    };
        
    crdl([        
        ['contact', auth_data, contact_data],
        ['event', 'login', properties]
    ]);
  }
});
